__turbopack_context__.v({
  "className": "inter_30aa2cef-module__IAjWIW__className",
  "variable": "inter_30aa2cef-module__IAjWIW__variable",
});
